export const SYSTEM_VERSION = '1.0.4'
